import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['documentList', 'isLowerClass', 'chooseLowerClass'];

  connect() {
    document.addEventListener('change', this.checkboxChange.bind(this));
  }

  checkboxChange(e) {
    const allThings = this.nodeArray('input');
    let check = e.target;

    //  exit if change event did not come from
    //  our list of allThings
    if (allThings.indexOf(check) === -1) return;

    //  check/un-check children (includes check itself)
    const children = this.nodeArray('input', check.parentNode);
    children.forEach((child) => (child.checked = check.checked));

    //  traverse up from target check
    while (check) {
      //  find parent and sibling checkboxes
      const parent = check.closest(['ul']).parentNode.querySelector('input');
      const siblings = this.nodeArray(
        'input',
        parent.closest('li').querySelector(['ul'])
      );

      //  get checked state of siblings
      //  are every or some siblings checked (using Boolean as test f unction)
      const checkStatus = siblings.map((check) => check.checked);
      const every = checkStatus.every(Boolean);
      const some = checkStatus.some(Boolean);

      //  check parent if all siblings are checked
      //  set indeterminate if not all and not none are checked
      parent.checked = every;
      parent.indeterminate = !every && every !== some;

      //  prepare for nex loop
      check = check != parent ? parent : 0;
    }
  }

  nodeArray(selector, parent = this.documentListTarget) {
    return [].slice.call(parent.querySelectorAll(selector));
  }

  toggleSelectDocuments() {
    var employee = this.isLowerClassTarget.options[
      this.isLowerClassTarget.selectedIndex
    ].value;
    if (employee == 'worker') {
      this.chooseLowerClassTarget.style.display = 'none';
    }
    else {
      this.chooseLowerClassTarget.style.display = 'block';
    }
  }

  toggleForm() {
    var x = document.getElementById('step-1');
    var y = document.getElementById('step-2');
    var z = document.getElementById('circle-1');
    var a = document.getElementById('circle-2');

    if (x.style.display === 'none') {
      x.style.display = 'block';
      y.style.display = 'none';
      a.style.backgroundColor = '#A4A7B1';
      a.style.borderColor = '#A4A7B1';
      z.style.backgroundColor = '#CA2318';
    } else {
      x.style.display = 'none';
      y.style.display = 'block';
      a.style.borderColor = '#CA2318';
      a.style.backgroundColor = '#CA2318';
    }
  }
}
